import { useMemo, useSyncExternalStore } from 'react'
import { getAuthSnapshot, subscribeAuth } from './authStorage'
import { getAuthUser } from './authSession'
import type { AuthUser } from './authStorage'

export interface AuthState {
  /** A Better Auth session is stored on this device (true offline too). */
  isAuthenticated: boolean
  /** The signed-in user, or null when signed out or not loaded yet. */
  user: AuthUser | null
}

/**
 * Reactive view of the auth seam (replaces react-oidc-context's `useAuth`).
 * Re-renders on sign-in, sign-out and profile updates, including from other
 * tabs once AuthProvider's scheduler is listening.
 */
export function useAuth(): AuthState {
  const snapshot = useSyncExternalStore(subscribeAuth, getAuthSnapshot, getAuthSnapshot)
  // Memoised on the snapshot so `user` is referentially stable between
  // changes and safe to use as an effect dependency.
  return useMemo(
    () => ({
      isAuthenticated: snapshot.isAuthenticated,
      user: snapshot.isAuthenticated ? (snapshot.user ?? getAuthUser()) : null,
    }),
    [snapshot],
  )
}
